<template>
  <div class="transactions-page">
    <div class="page-header">
      <div class="header-left">
        <button class="back-btn" @click="$router.go(-1)">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="title-group">
          <h1 class="page-title">Employee Stock Transactions</h1>
          <p class="page-subtitle">Track all equity transaction history</p>
        </div>
      </div>
    </div>
    <div class="table-container">
      <EsopTransactionsTable />
    </div>
  </div>
</template>

<script>
import EsopTransactionsTable from "@/components/tables/esop/EsopTransactionsTable";

export default {
  name: "EsopTransactions",

  components: {
    EsopTransactionsTable,
  },
};
</script>

<style lang="scss" scoped>
.transactions-page {
  @include fadeIn;
  padding: 24px 20px 32px;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 32px;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-top: 2px;

  &:hover {
    background: white;
    border-color: #4D84FF;
    color: #4D84FF;
  }
}

.title-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.page-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 22px;
  font-weight: 500;
  color: #0F172A;
  margin: 0;
}

.page-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: #64748B;
  margin: 0;
}

.table-container {
  background: white;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}
</style>
